var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advantage-container"},[_c('div',{staticClass:"title"},[_vm._v(" 数智时代包车客运痛点 ")]),_c('div',{staticClass:"list flex flex-between"},[_vm._l((_vm.list),function(item,index){return [_c('img',{class:'item' + (index + 1),attrs:{"src":item,"alt":""}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }